module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/jTyyFv/tc-custom/9781607051497.jpg?1737686687012",
      "alt": "This image is the cover for the book Flying Colors"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Flying Colors\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Tips and techniques for unleashing the designer within and creating your own original quilts.")]), _c('br'), _c('br'), _vm._v("Let your imagination take flight! Gail Garber teaches you step-by-step techniques to create your own unique quilt designs, or to make any of the five bonus projects in this book. "), _c('br'), _c('br'), _vm._v("Draft shapes such as Flying Geese, triangles, and diamonds to fill strips of fabric that weave in and out of your design. Easy paper-piecing instructions help you make all your designs more accurate, from landscapes to radiating sunlight to flowing ribbons. Links to full-size foundation patterns are included, plus a gallery of quilts made by Gail and her students. Learn how to make intriguing quilts with techniques for using free-form strips and shapes to create dimension, illusion, and flow. There’s no limit to the designs you can invent!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gail Garber\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gail Garber first started quilting in 1980, and hasn't looked back since. Her award-winning work has been exhibited in numerous shows and published in a number of quilting magazines.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    C&T Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0